import { render, staticRenderFns } from "./NewsPaperDone.vue?vue&type=template&id=5bb3bffa"
import script from "./NewsPaperDone.vue?vue&type=script&lang=js"
export * from "./NewsPaperDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports